import { CircularProgress } from '@civilgrid/ui/components';
import { useSnapshot } from 'valtio';
import authorizations, { Action } from '~/authorizations';
import Can from '~/authorizations/Can';
import rootStore from '../../store';
import LeftNav from '../common/LeftNav';
import LeftNavSection from '../common/LeftNav/LeftNavSection';
import NavItem from '../common/LeftNav/NavItem';

export default function LeftNavComponent() {
  const { currentOrganization } = useSnapshot(rootStore) as typeof rootStore;
  const showLayersSection = authorizations.can(Action.ManageOrgLayerConfig);

  if (!currentOrganization) {
    return <CircularProgress indeterminate />;
  }

  return (
    <LeftNav aria-label="Organization">
      <div className="sticky -top-2 bg-white">
        <div className="-mt-2 mb-4 border-l-4 border-brand bg-white p-1">
          <div className="font-medium">{currentOrganization.name}</div>
        </div>

        <div className="my-2 h-[1px] border-b" />
      </div>
      <LeftNavSection title="">
        <NavItem to={`/orgSettings/general`} data-testid="org-nav-general">
          General
        </NavItem>
        <Can action={Action.ViewSubscriptionInfo}>
          <NavItem to={`/orgSettings/plan`} data-testid="org-nav-plan">
            Plan
          </NavItem>
        </Can>
        <Can action={Action.ViewSubscriptionInfo}>
          <NavItem to={`/orgSettings/billing`} data-testid="org-nav-billing">
            Billing
          </NavItem>
        </Can>
      </LeftNavSection>

      <LeftNavSection title="Team" isLast={!showLayersSection}>
        <Can action={Action.ViewOrgSettings}>
          <NavItem to="/orgSettings/members" data-testid="org-nav-members">
            Members
          </NavItem>
        </Can>
        <Can action={Action.UpdateOrgPermissions}>
          <NavItem to="/orgSettings/roles" data-testid="org-nav-roles">
            Roles & Permissions
          </NavItem>
        </Can>
      </LeftNavSection>

      {showLayersSection && (
        <LeftNavSection title="Layers" isLast>
          <NavItem to="/orgSettings/layerLibrary" data-testid="org-nav-layerLibrary">
            Default Settings
          </NavItem>
        </LeftNavSection>
      )}
    </LeftNav>
  );
}
